import React from 'react'
import HeroImage1 from '../images/hero-images/sentinel-banner-at-finger-tips.jpg'
import HeroImage2 from '../images/hero-images/sentinel-banner-action-now.jpg'
import HeroImage3 from '../images/hero-images/sentinel-banner-performance.jpg'
import HeroImage4 from '../images/hero-images/sentinel-banner-monitor-all.jpg'
import HeroImage5 from '../images/hero-images/banner-on-any-device.jpeg'

const slides = [

    {
        id: 2,
        image: HeroImage2,
        mainText: 'The Unfied Observability<br /> And Security Platform <br />  <span>Sentinel</span>',
        subText: 'Hardware, Software, Factory Machinery, Sensors, On-premise, Cloud, etc. ',
        action: {
            'link': '/'
        }
    },
    {
        id: 3,
        image: HeroImage3,
        mainText: 'Action<br /><span> Immediately</span>',
        subText: 'No delays, lags, or lead times.',
        action: {
            'link': '/'
        }
    },
    {
        id:4,
        image: HeroImage4,
        mainText: 'Always At Your   <br /> <span>Fingertips</span>',
        subText: 'Track From Any Device - Time - Location',
        action: {
            'link': '/'
        }
    },
    {
        id: 5,
        image: HeroImage1,
    
        mainText: 'Constant Performance & <br /><span> Quality</span>',
        subText: 'Transform from a Reactive to a Proactive environment.'
    }
]

const HeroSlides = () => {

    return (
        <div className="hero-wrap" id="sec1" data-scrollax-parent="true">
            <div className="slider-carousel-wrap full-height fullscreen-slider-wrap">
                <div className="fullscreen-slider full-height cur_carousel-slider-container fl-wrap" data-slick='{"autoplay": true, "autoplaySpeed": 4000 , "pauseOnHover": false}'>
                {slides.map(slide => (
                    <div key={slide.image} className="fullscreen-slider-item full-height fl-wrap">
                        <div className="bg par-elem hero-bg"  data-bg={slide.image}></div>
                        <div className="overlay"></div>
                        <div className="half-hero-wrap">
                            <h1 dangerouslySetInnerHTML={{ __html: slide.mainText }}></h1>
                            <h4>{slide.subText}</h4>
                            <div className="clearfix"></div>
                            {/* <a href={slide.action.link} className="custom-scroll-link btn float-btn flat-btn color-btn mar-top">Let's Start</a> */}
                        </div>
                    </div>
                ))}
                </div>
                <div className="sp-cont   sp-cont-prev"><i className="fal fa-arrow-left"></i></div>
                <div className="sp-cont   sp-cont-next"><i className="fal fa-arrow-right"></i></div>
                <div className="fullscreenslider-counter"></div>
            </div>
            <div className="hero-decor-numb">
                <span>6.9149106  </span><span>79.9105932 </span>
                <a href="https://g.page/PragICTS?share" target="_blank" className="hero-decor-numb-tooltip">Based In Colombo, Sri Lanka</a>
            </div>
        </div>
    )
}

export default HeroSlides
